// extracted by mini-css-extract-plugin
module.exports = {"header":"modalheader_header__35uCu","title":"modalheader_title__3k7vv","closeBtn":"modalheader_closeBtn__AcJ2O"};